import { ProfileView } from "@authory-packages/core";

export const getViewName = (view: ProfileView) => {
    switch (view) {
        case ProfileView.TwoColumnThumbnail:
            return "Grid";
        case ProfileView.OneColumnThumbnail:
            return "Stacked";
        case ProfileView.List:
            return "List";
        case ProfileView.Text:
            return "Text";
        case ProfileView.Masonry:
            return "Masonry";
        default:
            return "";
    }
};
